{
  "supplemental": {
    "version": {
      "_unicodeVersion": "16.0.0",
      "_cldrVersion": "47"
    },
    "weekData": {
      "minDays": {
        "001": "1",
        "AD": "4",
        "AN": "4",
        "AT": "4",
        "AX": "4",
        "BE": "4",
        "BG": "4",
        "CH": "4",
        "CZ": "4",
        "DE": "4",
        "DK": "4",
        "EE": "4",
        "ES": "4",
        "FI": "4",
        "FJ": "4",
        "FO": "4",
        "FR": "4",
        "GB": "4",
        "GF": "4",
        "GG": "4",
        "GI": "4",
        "GP": "4",
        "GR": "4",
        "GU": "1",
        "HU": "4",
        "IE": "4",
        "IM": "4",
        "IS": "4",
        "IT": "4",
        "JE": "4",
        "LI": "4",
        "LT": "4",
        "LU": "4",
        "MC": "4",
        "MQ": "4",
        "NL": "4",
        "NO": "4",
        "PL": "4",
        "PT": "4",
        "RE": "4",
        "RU": "4",
        "SE": "4",
        "SJ": "4",
        "SK": "4",
        "SM": "4",
        "UM": "1",
        "US": "1",
        "VA": "4",
        "VI": "1"
      },
      "firstDay": {
        "001": "mon",
        "AD": "mon",
        "AE": "mon",
        "AF": "sat",
        "AG": "sun",
        "AI": "mon",
        "AL": "mon",
        "AM": "mon",
        "AN": "mon",
        "AR": "mon",
        "AS": "sun",
        "AT": "mon",
        "AU": "mon",
        "AX": "mon",
        "AZ": "mon",
        "BA": "mon",
        "BD": "sun",
        "BE": "mon",
        "BG": "mon",
        "BH": "sat",
        "BM": "mon",
        "BN": "mon",
        "BR": "sun",
        "BS": "sun",
        "BT": "sun",
        "BW": "sun",
        "BY": "mon",
        "BZ": "sun",
        "CA": "sun",
        "CH": "mon",
        "CL": "mon",
        "CM": "mon",
        "CN": "mon",
        "CO": "sun",
        "CR": "mon",
        "CY": "mon",
        "CZ": "mon",
        "DE": "mon",
        "DJ": "sat",
        "DK": "mon",
        "DM": "sun",
        "DO": "sun",
        "DZ": "sat",
        "EC": "mon",
        "EE": "mon",
        "EG": "sat",
        "ES": "mon",
        "ET": "sun",
        "FI": "mon",
        "FJ": "mon",
        "FO": "mon",
        "FR": "mon",
        "GB": "mon",
        "GB-alt-variant": "sun",
        "GE": "mon",
        "GF": "mon",
        "GP": "mon",
        "GR": "mon",
        "GT": "sun",
        "GU": "sun",
        "HK": "sun",
        "HN": "sun",
        "HR": "mon",
        "HU": "mon",
        "ID": "sun",
        "IE": "mon",
        "IL": "sun",
        "IN": "sun",
        "IQ": "sat",
        "IR": "sat",
        "IS": "mon",
        "IT": "mon",
        "JM": "sun",
        "JO": "sat",
        "JP": "sun",
        "KE": "sun",
        "KG": "mon",
        "KH": "sun",
        "KR": "sun",
        "KW": "sat",
        "KZ": "mon",
        "LA": "sun",
        "LB": "mon",
        "LI": "mon",
        "LK": "mon",
        "LT": "mon",
        "LU": "mon",
        "LV": "mon",
        "LY": "sat",
        "MC": "mon",
        "MD": "mon",
        "ME": "mon",
        "MH": "sun",
        "MK": "mon",
        "MM": "sun",
        "MN": "mon",
        "MO": "sun",
        "MQ": "mon",
        "MT": "sun",
        "MV": "fri",
        "MX": "sun",
        "MY": "mon",
        "MZ": "sun",
        "NI": "sun",
        "NL": "mon",
        "NO": "mon",
        "NP": "sun",
        "NZ": "mon",
        "OM": "sat",
        "PA": "sun",
        "PE": "sun",
        "PH": "sun",
        "PK": "sun",
        "PL": "mon",
        "PR": "sun",
        "PT": "sun",
        "PY": "sun",
        "QA": "sat",
        "RE": "mon",
        "RO": "mon",
        "RS": "mon",
        "RU": "mon",
        "SA": "sun",
        "SD": "sat",
        "SE": "mon",
        "SG": "sun",
        "SI": "mon",
        "SK": "mon",
        "SM": "mon",
        "SV": "sun",
        "SY": "sat",
        "TH": "sun",
        "TJ": "mon",
        "TM": "mon",
        "TR": "mon",
        "TT": "sun",
        "TW": "sun",
        "UA": "mon",
        "UM": "sun",
        "US": "sun",
        "UY": "mon",
        "UZ": "mon",
        "VA": "mon",
        "VE": "sun",
        "VI": "sun",
        "VN": "mon",
        "WS": "sun",
        "XK": "mon",
        "YE": "sun",
        "ZA": "sun",
        "ZW": "sun"
      },
      "weekendStart": {
        "001": "sat",
        "AF": "thu",
        "BH": "fri",
        "DZ": "fri",
        "EG": "fri",
        "IL": "fri",
        "IN": "sun",
        "IQ": "fri",
        "IR": "fri",
        "JO": "fri",
        "KW": "fri",
        "LY": "fri",
        "OM": "fri",
        "QA": "fri",
        "SA": "fri",
        "SD": "fri",
        "SY": "fri",
        "UG": "sun",
        "YE": "fri"
      },
      "weekendEnd": {
        "001": "sun",
        "AF": "fri",
        "BH": "sat",
        "DZ": "sat",
        "EG": "sat",
        "IL": "sat",
        "IQ": "sat",
        "IR": "fri",
        "JO": "sat",
        "KW": "sat",
        "LY": "sat",
        "OM": "sat",
        "QA": "sat",
        "SA": "sat",
        "SD": "sat",
        "SY": "sat",
        "YE": "sat"
      },
      "weekOfPreference": {
        "af": [
          "weekOfDate",
          "weekOfInterval",
          "weekOfMonth"
        ],
        "am": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "az": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "bs": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "cs": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "cy": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "da": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "el": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "et": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "hi": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "ky": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "lt": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "mk": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "sk": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "ta": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "th": [
          "weekOfYear",
          "weekOfMonth"
        ],
        "ar": [
          "weekOfMonth"
        ],
        "fil": [
          "weekOfMonth"
        ],
        "gu": [
          "weekOfMonth"
        ],
        "hu": [
          "weekOfMonth"
        ],
        "hy": [
          "weekOfMonth"
        ],
        "id": [
          "weekOfMonth"
        ],
        "kk": [
          "weekOfMonth"
        ],
        "ko": [
          "weekOfMonth"
        ],
        "be": [
          "weekOfInterval",
          "weekOfMonth"
        ],
        "ro": [
          "weekOfInterval",
          "weekOfMonth"
        ],
        "ru": [
          "weekOfInterval",
          "weekOfMonth"
        ],
        "bg": [
          "weekOfDate",
          "weekOfMonth",
          "weekOfInterval"
        ],
        "de": [
          "weekOfDate",
          "weekOfMonth",
          "weekOfInterval"
        ],
        "he": [
          "weekOfDate",
          "weekOfMonth",
          "weekOfInterval"
        ],
        "pt": [
          "weekOfDate",
          "weekOfMonth",
          "weekOfInterval"
        ],
        "ur": [
          "weekOfDate",
          "weekOfMonth",
          "weekOfInterval"
        ],
        "zh": [
          "weekOfDate",
          "weekOfMonth",
          "weekOfInterval"
        ],
        "ca": [
          "weekOfDate"
        ],
        "es": [
          "weekOfDate"
        ],
        "fr": [
          "weekOfDate"
        ],
        "gl": [
          "weekOfDate"
        ],
        "en": [
          "weekOfDate",
          "weekOfMonth"
        ],
        "bn": [
          "weekOfDate",
          "weekOfMonth"
        ],
        "ja": [
          "weekOfDate",
          "weekOfMonth"
        ],
        "ka": [
          "weekOfDate",
          "weekOfMonth"
        ],
        "eu": [
          "weekOfMonth",
          "weekOfDate"
        ],
        "fa": [
          "weekOfMonth",
          "weekOfInterval"
        ],
        "hr": [
          "weekOfMonth",
          "weekOfInterval"
        ],
        "it": [
          "weekOfMonth",
          "weekOfInterval"
        ],
        "lv": [
          "weekOfMonth",
          "weekOfInterval"
        ],
        "pl": [
          "weekOfMonth",
          "weekOfInterval"
        ],
        "si": [
          "weekOfMonth",
          "weekOfInterval"
        ],
        "sr": [
          "weekOfMonth",
          "weekOfInterval"
        ],
        "uk": [
          "weekOfMonth",
          "weekOfInterval"
        ],
        "uz": [
          "weekOfMonth",
          "weekOfInterval"
        ],
        "fi": [
          "weekOfYear",
          "weekOfDate",
          "weekOfMonth"
        ],
        "zh-TW": [
          "weekOfYear",
          "weekOfDate",
          "weekOfMonth"
        ],
        "is": [
          "weekOfYear",
          "weekOfMonth",
          "weekOfInterval"
        ],
        "mn": [
          "weekOfYear",
          "weekOfMonth",
          "weekOfInterval"
        ],
        "nb": [
          "weekOfYear",
          "weekOfMonth",
          "weekOfInterval"
        ],
        "no": [
          "weekOfYear",
          "weekOfMonth",
          "weekOfInterval"
        ],
        "sv": [
          "weekOfYear",
          "weekOfMonth",
          "weekOfInterval"
        ],
        "vi": [
          "weekOfYear",
          "weekOfMonth",
          "weekOfInterval"
        ],
        "km": [
          "weekOfMonth",
          "weekOfYear"
        ],
        "mr": [
          "weekOfMonth",
          "weekOfYear"
        ],
        "kn": [
          "weekOfMonth",
          "weekOfDate",
          "weekOfYear"
        ],
        "ml": [
          "weekOfMonth",
          "weekOfDate",
          "weekOfYear"
        ],
        "pa": [
          "weekOfMonth",
          "weekOfDate",
          "weekOfYear"
        ],
        "lo": [
          "weekOfMonth",
          "weekOfInterval",
          "weekOfDate",
          "weekOfYear"
        ],
        "sq": [
          "weekOfMonth",
          "weekOfInterval",
          "weekOfDate",
          "weekOfYear"
        ],
        "ms": [
          "weekOfMonth",
          "weekOfYear",
          "weekOfInterval",
          "weekOfDate"
        ],
        "tr": [
          "weekOfMonth",
          "weekOfYear",
          "weekOfInterval",
          "weekOfDate"
        ],
        "nl": [
          "weekOfDate",
          "weekOfYear",
          "weekOfMonth"
        ],
        "sl": [
          "weekOfInterval"
        ],
        "sw": [
          "weekOfMonth",
          "weekOfInterval",
          "weekOfYear"
        ],
        "te": [
          "weekOfMonth",
          "weekOfInterval",
          "weekOfYear"
        ],
        "und": [
          "weekOfYear"
        ],
        "zu": [
          "weekOfYear",
          "weekOfInterval"
        ]
      }
    }
  }
}
